import { apiClient, ApiResponse } from '@/services/core/apiClient';

export interface AddPatientPayload {
  firstName: string;
  middleName?: string;
  lastName: string;
  dob: string;
  gender: string;
  emrId: string;
  clinicFacilityId: number;
  clinicId: number;
  providerId: number;
  addressLineOne: string;
  addressLineTwo?: string;
  city: string;
  state: string;
  zipCode: string;
  email?: string;
  mobileNumber: string;
  homeNumber?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  primaryInsuranceProvider?: string;
  primaryInsurancePolicyNumber?: string;
  secondaryInsuranceProvider?: string;
  secondaryInsurancePolicyNumber?: string;
  isActive: boolean;
  // Program Eligibility - only sent if true
  isCcmEligible?: boolean;
  isRpmEligible?: boolean;
  isPcmEligible?: boolean;
}

export interface AddPatientResponse {
  id?: number;
  message?: string;
}

class AddPatientService {
  /**
   * Add a new patient
   */
  async addPatient(
    adminId: string | number,
    payload: AddPatientPayload,
    token: string
  ): Promise<ApiResponse<AddPatientResponse>> {
    const endpoint = `/api/ngpep/${adminId}/patient`;
    return apiClient.post<AddPatientResponse>(endpoint, payload, token);
  }
}

export const addPatientService = new AddPatientService();
export default addPatientService;
